/* global angular, moment */
/**
 * Created by lari on 01/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcclient')
    .component('patientheader', {
      restrict: 'E',
      bindings: {
        client: '<?',
        clientid: '<?',
        mode: '<?'
      },
      template: `
       <div class="row">
      <div class="col-xs-4 col-md-2">
        <img ng-src="{{vm.client.image}}" class="img-responsive"
             alt="{{vm.client.primarycontact.firstname}} {{vm.client.primarycontact.lastname}}">
        <imagecapture captureid="clientphoto" clientid="vm.client._id" class="imgcapture" filehandle="vm.client.image" filecat="patientavatar"></imagecapture>
      </div>
      <div class="col-xs-8 col-md-10">
        <h3>
        <span class="pull-left">
          <span class="rwd-line">
            <span ng-show="vm.client.primarycontact.titlefront" class="hidden-xs hidden-sm">{{vm.client.primarycontact.titlefront}} </span>
                {{vm.client.primarycontact.firstname}} {{vm.client.primarycontact.lastname}}
                <i class="fa fa-mars text-primary" ng-show="vm.client.primarycontact.gender === 'männlich'"></i>
                <i class="fa fa-venus text-danger" ng-show="vm.client.primarycontact.gender === 'weiblich'"></i>
                <i class="fa fa-venus-mars text-success" ng-show="vm.client.primarycontact.gender === 'unbekannt'"></i>
            <span ng-show="vm.client.primarycontact.titleback" class="hidden-xs hidden-sm">, {{vm.client.primarycontact.titleback}} </span>,
          </span>
          <span class="rwd-line">
            *&nbsp;{{vm.client.svdata.bdateat}}
            <a ui-sref="dms.signoffperson({clientid: vm.client._id})"> <signoffcounter patientid="vm.client._id"></signoffcounter></a>
          </span>
        </span>
        <span class="mypull-right">
            <riskviewer risk="vm.client.risk"></riskviewer>
        </span>
        </h3>
        <div class="clearfix"></div>
        <div class="hidden-xs hidden-sm"><diagnosesedit diagnoses="vm.client.diagnoses" deleteddiagnoses="vm.client.deleteddiagnoses" parentsave="vm.childsave()" deleteable="true"></diagnosesedit></div>
      </div>
      <div class="hidden-md hidden-lg  hidden-xl col-xs-12"><diagnosesedit diagnoses="vm.client.diagnoses" parentsave="vm.childsave()"></diagnosesedit></div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'ClientHelper', 'vertxEventBusService', '$window', '$timeout',
        function ($log, Rlog, ClientHelper, vertxEventBusService, $window, $timeout) {
          let vm = this;
          vm.childsave = childsave;


          vm.$onInit = function () {

            if (angular.isDefined(vm.mode) && vm.mode === 'patient') {
              vm.kunde = 'Patient';
              vm.testkunde = 'Testpatient';
            } else {
              vm.mode = 'client';
              vm.kunde = 'Kunde';
              vm.testkunde = 'Testkunde';
            }

            if (angular.isDefined(vm.clientid) && angular.isString(vm.clientid) && vm.clientid.length > 0) {
              ClientHelper.find(vm.mode, vm.clientid).$then(function (client) {
                vm.client = client;
                if (angular.isUndefined(vm.client.deleteddiagnoses) || !angular.isArray(vm.client.deleteddiagnoses)) {
                  vm.client.deleteddiagnoses = [];
                  vm.client.$save();
                  $log.debug('initalised deleteddiagnoses to empty array');
                }
              }, function (err) {
                vm.error = 'Der ' + vm.kunde + ' mit der Nummer ' + vm.clientid + ' konnte nicht gefunden werden! Der Fehler wurde protokolliert.';
                Rlog.error('client', 'patientheader', 'client.$find() failed', {id: vm.clientid});
              });


            }
          }; // $onInit()

          // vm.clientid might be late propagating, get consult on first change / wasn't needed as all id are resolved in router


          function childsave() {
            $log.debug('**** patientheader childsave called:', vm.client.diagnoses);
            if (!angular.equals(vm.client, vm.lastclient)) {
              vm.client.flatdiagnoses = vm.client.diagnoses.map(function (diag) {
                return diag.key;
              });
              $log.debug('**** patientheader saving child :', vm.client.diagnoses, vm.client.flatdiagnoses);
              vm.lastclient = angular.copy(vm.client);
              if (vm.client.$hasPendingActions) {
                $log.warn('[CLIENT][PatientHeader] client save had pending actions, cancelling now.');

                vm.client.$cancel();
                $timeout(function () {
                  $log.warn('[CLIENT][PatientHeader]  waited 1.5 seconds because of client having had pending actions, saving now.');
                  savesave();
                }, 1500);
              } else {
                savesave();
              }

            }
          }

          function savesave() {
            vm.client.$save().$then(function () {
            }, function (err) {
              $log.error('[CLIENT][PatientHeader] debug/error: client save failed!', err);
              Rlog.error('client', 'clienteditor', 'client.$save() failed', {id: vm.client._id});
            });
          }


          function resetOrientation(srcBase64, srcOrientation, callback) {
            var img = new Image();

            img.onload = function () {
              var width = img.width,
                height = img.height,
                canvas = document.createElement('canvas'),
                ctx = canvas.getContext("2d");

              // set proper canvas dimensions before transform & export
              if (4 < srcOrientation && srcOrientation < 9) {
                canvas.width = height;
                canvas.height = width;
              } else {
                canvas.width = width;
                canvas.height = height;
              }

              // transform context before drawing image
              switch (srcOrientation) {
                case 2:
                  ctx.transform(-1, 0, 0, 1, width, 0);
                  break;
                case 3:
                  ctx.transform(-1, 0, 0, -1, width, height);
                  break;
                case 4:
                  ctx.transform(1, 0, 0, -1, 0, height);
                  break;
                case 5:
                  ctx.transform(0, 1, 1, 0, 0, 0);
                  break;
                case 6:
                  ctx.transform(0, 1, -1, 0, height, 0);
                  break;
                case 7:
                  ctx.transform(0, -1, -1, 0, height, width);
                  break;
                case 8:
                  ctx.transform(0, -1, 1, 0, 0, width);
                  break;
                default:
                  break;
              }

              // draw image
              ctx.drawImage(img, 0, 0);

              // export base64
              callback(canvas.toDataURL());
            };

            img.src = srcBase64;
          }


          const patientsUpdateHandler = function (message) {
            $log.debug('debug: Patient update received: ', message);
            let messages = message.split(':');
            // $log.debug('debug: $tabid: ', $window.sessionStorage.getItem('sprtabid'));
            // if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
            if (angular.isDefined(vm.client) && vm.client._id === messages[0]) {
              vm.client.$refresh().$then(function () {
                $log.debug('debug: patientheader refreshed patient: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
              }, function (error) {
                $log.debug('debug: patientehader could not refresh patient: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
              });
            }
          };

          const clientsUpdateHandler = function (message) {
            $log.debug('debug: Client update received: ', message);
            let messages = message.split(':');
            // if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
            if (angular.isDefined(vm.client) && vm.client._id === messages[0]) {
              vm.client.$refresh().$then(function () {
                $log.debug('debug: patientheader refreshed client: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
              }, function (error) {
                $log.debug('debug: clienteditor could not refresh client: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
              });
            }
          };

          vertxEventBusService.on('patients.update', {}, patientsUpdateHandler);
          vertxEventBusService.on('clients.update', {}, clientsUpdateHandler);


          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('patients.update', {}, patientsUpdateHandler);
            vertxEventBusService.unregisterHandler('clients.update', {}, clientsUpdateHandler);
          };


        }] // controller
    }); // component

// klammerfriedhof
}());
